import { render } from "./invitado_evento_ingles.vue?vue&type=template&id=634352db&scoped=true"
import script from "./invitado_evento_ingles.vue?vue&type=script&lang=js"
export * from "./invitado_evento_ingles.vue?vue&type=script&lang=js"

import "./invitado_evento_ingles.vue?vue&type=style&index=0&id=634352db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634352db"]])

export default __exports__